import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TrinidadAndTobagoFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16053'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16053)'>
				<rect
					width='20'
					height='14'
					fill='#ED233C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.6208 17.7944L-0.0448837 0.666069L5.37927 -3.79431L20.0449 13.334L14.6208 17.7944Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M17.0533 18.867L-0.699841 -1.86727L2.94799 -4.86694L20.7012 15.8673L17.0533 18.867Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default TrinidadAndTobagoFlagIcon;
